import script from "./Krediflow-External-Workflow.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-External-Workflow.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-External-Workflow.vue?vue&type=style&index=0&id=688e95e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688e95e4"]])

export default __exports__